import React from 'react';
import Button from '@material-ui/core/Button';
import { extendPatientTransactionCode } from '../../services/transaction.service';
import { TRANSACTIONS_CONSTANT } from '../../constants/common';
import ResendPurchaseCode from './resendPurchaseCode';
import ResendRedemptionCode from './resendRedemptionCode';
import moment from 'moment-timezone';

const extendTransactionCode = ({ data }) => {
    const { promo_code, transaction_code_id, program_id, voided_at, status, type, code_expiration } = data;

    const onClick = async () => {
        if (window.confirm(`Do you want to extend the validity of this code ${promo_code}?`)) {
            await extendPatientTransactionCode({
                program_id,
                transaction_code_id,
            })
            .then((res) => {
                alert(res.message);
                window.location.reload();
            })
            .catch((err) => alert(err.message));
        }
    };

    if (voided_at || status === TRANSACTIONS_CONSTANT.TRANSACTION_STATUS.VOIDED 
        || status === TRANSACTIONS_CONSTANT.TRANSACTION_STATUS.REDEEMED) {
        return <></>;
    }

    let buttonDisabled = false;
    if (moment(code_expiration).isAfter(moment())) {
        buttonDisabled = true;
    }

    return (
        <Button variant="contained" onClick={onClick} 
        style={{ marginRight: 8 }} disabled={buttonDisabled}>Extend Transaction Code</Button>
    )
}

export default extendTransactionCode;
